// Traductions des pages villes (contenu UAE en EN/AR) + libellés d'interface.
// Utilisé par CityPage.jsx. {city} est remplacé par le nom de la ville.

// Noms propres localisés des villes UAE (FR par défaut via cities.js).
export const CITY_NAMES = {
  dubai: { en: 'Dubai', ar: 'دبي' },
  'abu-dhabi': { en: 'Abu Dhabi', ar: 'أبوظبي' },
  sharjah: { en: 'Sharjah', ar: 'الشارقة' },
  ajman: { en: 'Ajman', ar: 'عجمان' },
  'ras-al-khaimah': { en: 'Ras Al Khaimah', ar: 'رأس الخيمة' },
  fujairah: { en: 'Fujairah', ar: 'الفجيرة' },
  'al-ain': { en: 'Al Ain', ar: 'العين' },
  paris: { en: 'Paris', ar: 'باريس' },
  lyon: { en: 'Lyon', ar: 'ليون' },
  marseille: { en: 'Marseille', ar: 'مرسيليا' },
  bordeaux: { en: 'Bordeaux', ar: 'بوردو' },
  lille: { en: 'Lille', ar: 'ليل' },
  toulouse: { en: 'Toulouse', ar: 'تولوز' },
  nice: { en: 'Nice', ar: 'نيس' },
  nantes: { en: 'Nantes', ar: 'نانت' },
  strasbourg: { en: 'Strasbourg', ar: 'ستراسبورغ' },
  montpellier: { en: 'Montpellier', ar: 'مونبلييه' },
  rennes: { en: 'Rennes', ar: 'رين' },
  grenoble: { en: 'Grenoble', ar: 'غرونوبل' },
};

export const CITY_I18N = {
  dubai: {
    en: {
      region: 'United Arab Emirates',
      intro:
        "Dubai is the world capital of high-end events: luxury weddings, corporate galas, rooftop parties and receptions in the finest hotels. Our synchronized LED wristband kits are distributed here through our local reseller and turn every event into a light show.",
      venues: ['luxury hotels & resorts (Palm, Downtown, Marina)', 'rooftops & beach clubs', 'galas & brand launches at DWTC', 'weddings & private receptions'],
    },
    ar: {
      region: 'الإمارات العربية المتحدة',
      intro:
        'دبي هي العاصمة العالمية للفعاليات الراقية: حفلات الزفاف الفاخرة والحفلات المؤسسية وسهرات الأسطح والاستقبالات في أرقى الفنادق. تُوزَّع أساور LED المتزامنة لدينا عبر موزّعنا المحلي وتحوّل كل فعالية إلى عرض ضوئي.',
      venues: ['الفنادق والمنتجعات الفاخرة (النخلة، وسط المدينة، المارينا)', 'الأسطح ونوادي الشاطئ', 'الحفلات وإطلاق العلامات التجارية في مركز دبي التجاري', 'حفلات الزفاف والاستقبالات الخاصة'],
    },
  },
  'abu-dhabi': {
    en: {
      region: 'United Arab Emirates',
      intro:
        'As the capital of the Emirates, Abu Dhabi hosts official galas, international conferences and grand receptions on Yas Island and the Corniche. Our synchronized LED wristbands bathe the crowd in light, controlled live.',
      venues: ['official galas & conferences', 'events on Yas Island', 'receptions on the Corniche', 'weddings & private parties'],
    },
    ar: {
      region: 'الإمارات العربية المتحدة',
      intro:
        'بصفتها عاصمة الإمارات، تستضيف أبوظبي الحفلات الرسمية والمؤتمرات الدولية والاستقبالات الكبرى في جزيرة ياس وعلى الكورنيش. تغمر أساور LED المتزامنة لدينا الحشود بالضوء مع تحكّم مباشر.',
      venues: ['الحفلات والمؤتمرات الرسمية', 'فعاليات جزيرة ياس', 'الاستقبالات على الكورنيش', 'حفلات الزفاف والسهرات الخاصة'],
    },
  },
  sharjah: {
    en: {
      region: 'United Arab Emirates',
      intro:
        'Sharjah, the cultural heart of the Emirates, hosts traditional weddings, festivals and family events. Our LED wristband kits add a spectacular touch of light to your celebrations.',
      venues: ['weddings & family receptions', 'cultural festivals', 'corporate events', 'lagoon-side parties'],
    },
    ar: {
      region: 'الإمارات العربية المتحدة',
      intro:
        'الشارقة، القلب الثقافي للإمارات، تستضيف حفلات الزفاف التقليدية والمهرجانات والفعاليات العائلية. تضيف أطقم أساور LED لدينا لمسة ضوئية مذهلة إلى احتفالاتكم.',
      venues: ['حفلات الزفاف والاستقبالات العائلية', 'المهرجانات الثقافية', 'فعاليات الشركات', 'السهرات على ضفاف البحيرة'],
    },
  },
  ajman: {
    en: {
      region: 'United Arab Emirates',
      intro:
        'Between seaside resorts and reception halls, Ajman is a favourite destination for weddings and private events. Our LED wristbands sync on their own to light up the whole gathering.',
      venues: ['resorts & private beaches', 'weddings & receptions', 'corporate parties', 'family events'],
    },
    ar: {
      region: 'الإمارات العربية المتحدة',
      intro:
        'بين المنتجعات الساحلية وقاعات الاستقبال، تُعدّ عجمان وجهة مفضلة لحفلات الزفاف والفعاليات الخاصة. تتزامن أساور LED لدينا تلقائياً لإضاءة الحضور بأكمله.',
      venues: ['المنتجعات والشواطئ الخاصة', 'حفلات الزفاف والاستقبالات', 'سهرات الشركات', 'الفعاليات العائلية'],
    },
  },
  'ras-al-khaimah': {
    en: {
      region: 'United Arab Emirates',
      intro:
        "Ras Al Khaimah, famous for its resorts and its iconic New Year's show, is a land of grand events. Our synchronized LED wristband kits amplify every highlight.",
      venues: ['resorts & hotel complexes', 'New Year events', 'beachfront weddings', 'corporate parties'],
    },
    ar: {
      region: 'الإمارات العربية المتحدة',
      intro:
        'رأس الخيمة، المشهورة بمنتجعاتها وعرضها الأيقوني لرأس السنة، أرض الفعاليات الكبرى. تُضاعف أطقم أساور LED المتزامنة لدينا روعة كل لحظة.',
      venues: ['المنتجعات والمجمعات الفندقية', 'فعاليات رأس السنة', 'حفلات الزفاف على الشاطئ', 'سهرات الشركات'],
    },
  },
  fujairah: {
    en: {
      region: 'United Arab Emirates',
      intro:
        'On the east coast of the Emirates, Fujairah charms with resorts facing the Indian Ocean. Our LED wristbands turn weddings and receptions into true light displays.',
      venues: ['east coast resorts', 'seafront weddings', 'corporate events', 'private receptions'],
    },
    ar: {
      region: 'الإمارات العربية المتحدة',
      intro:
        'على الساحل الشرقي للإمارات، تأسر الفجيرة بمنتجعاتها المطلّة على المحيط الهندي. تحوّل أساور LED لدينا حفلات الزفاف والاستقبالات إلى لوحات ضوئية حقيقية.',
      venues: ['منتجعات الساحل الشرقي', 'حفلات الزفاف المطلة على البحر', 'فعاليات الشركات', 'الاستقبالات الخاصة'],
    },
  },
  'al-ain': {
    en: {
      region: 'United Arab Emirates',
      intro:
        'Al Ain, the UNESCO-listed Garden City, hosts weddings and receptions in a unique setting. Our synchronized LED wristband kits create a memorable atmosphere.',
      venues: ['weddings & large receptions', 'family events', 'corporate parties', 'local festivals'],
    },
    ar: {
      region: 'الإمارات العربية المتحدة',
      intro:
        'العين، المدينة الحديقة المدرجة في قائمة اليونسكو، تستضيف حفلات الزفاف والاستقبالات في أجواء فريدة. تخلق أطقم أساور LED المتزامنة لدينا أجواءً لا تُنسى.',
      venues: ['حفلات الزفاف والاستقبالات الكبرى', 'الفعاليات العائلية', 'سهرات الشركات', 'المهرجانات المحلية'],
    },
  },
  paris: {
    en: { region: 'Île-de-France', intro: 'Paris gathers the finest reception venues, major clubs and company headquarters looking for a memorable animation. Our LED wristband kits are delivered ready to use across the capital.', venues: ['reception venues in the Marais', 'Parisian clubs & rooftops', 'trade shows at Porte de Versailles', 'corporate parties at La Défense'] },
    ar: { region: 'فرنسا', intro: 'تجمع باريس أرقى قاعات الاستقبال وأكبر النوادي ومقرات الشركات الباحثة عن فعالية لا تُنسى. تُسلَّم أطقم أساور LED لدينا جاهزة للاستخدام في جميع أنحاء العاصمة.', venues: ['قاعات الاستقبال في حي الماريه', 'النوادي والأسطح الباريسية', 'المعارض في بورت دو فرساي', 'سهرات الشركات في لا ديفانس'] },
  },
  lyon: {
    en: { region: 'Auvergne-Rhône-Alpes', intro: 'From the Presqu\'île to the estates of the Monts d\'Or, Lyon hosts weddings, galas and student parties all year round. We deliver your synchronized LED wristbands across the Rhône.', venues: ['wedding estates in the Monts d\'Or', 'clubs of the Presqu\'île', 'corporate events at La Part-Dieu', 'festivals across the metropolis'] },
    ar: { region: 'فرنسا', intro: 'من جزيرة بريسكيل إلى ضيعات مون دور، تستضيف ليون حفلات الزفاف والحفلات الرسمية وسهرات الطلاب طوال العام. نوصّل أساور LED المتزامنة في جميع أنحاء الرون.', venues: ['ضيعات الزفاف في مون دور', 'نوادي بريسكيل', 'فعاليات الشركات في لا بار-ديو', 'مهرجانات المدينة'] },
  },
  marseille: {
    en: { region: 'Provence-Alpes-Côte d\'Azur', intro: 'Seaside parties, weddings in Provençal estates, open-air concerts: in Marseille, a whole crowd lighting up is seen from afar. Delivery across the Bouches-du-Rhône.', venues: ['Provençal estates & bastides', 'private beaches & beach clubs', 'venues near the Vieux-Port', 'sports & club events'] },
    ar: { region: 'فرنسا', intro: 'سهرات على شاطئ البحر، وحفلات زفاف في الضيعات، وحفلات في الهواء الطلق: في مرسيليا، يُرى الحشد المضيء من بعيد. التوصيل في جميع أنحاء بوش دو رون.', venues: ['الضيعات ومنازل بروفانس', 'الشواطئ الخاصة ونوادي الشاطئ', 'القاعات قرب الميناء القديم', 'الفعاليات الرياضية والنوادي'] },
  },
  bordeaux: {
    en: { region: 'Nouvelle-Aquitaine', intro: 'Wine châteaux, riverside quays and grand halls: Bordeaux is a city of upscale events where a light animation makes the difference in photos and memories.', venues: ['wine châteaux & estates', 'weddings in Médoc & Saint-Émilion', 'corporate parties at Bordeaux Lac', 'clubs & bars on the quays'] },
    ar: { region: 'فرنسا', intro: 'قصور النبيذ والأرصفة والقاعات الكبرى: بوردو مدينة الفعاليات الراقية حيث تصنع الإضاءة الفارق في الصور والذكريات.', venues: ['قصور وضيعات النبيذ', 'حفلات الزفاف في ميدوك وسان إميليون', 'سهرات الشركات في بوردو لاك', 'النوادي والحانات على الأرصفة'] },
  },
  lille: {
    en: { region: 'Hauts-de-France', intro: 'Lille and its metropolis live to the rhythm of student parties, fairs and big corporate events. Our kits arrive ready to hand out, with no installation.', venues: ['student parties & unions', 'reception venues of the metropolis', 'concerts at the Zénith and Aéronef', 'galas & conferences at Euralille'] },
    ar: { region: 'فرنسا', intro: 'تعيش ليل ومنطقتها على إيقاع سهرات الطلاب والأسواق والفعاليات المؤسسية الكبرى. تصل أطقمنا جاهزة للتوزيع دون أي تركيب.', venues: ['سهرات الطلاب والجمعيات', 'قاعات استقبال المدينة', 'الحفلات الموسيقية في زينيت وأيروناف', 'الحفلات والمؤتمرات في أوراليل'] },
  },
  toulouse: {
    en: { region: 'Occitanie', intro: 'Weddings in Haute-Garonne, aerospace company parties, summer festivals: Toulouse loves big gatherings. Your LED wristbands sync on their own from the first second.', venues: ['wedding estates in Haute-Garonne', 'aerospace corporate parties', 'festivals & village fairs', 'city-centre clubs'] },
    ar: { region: 'فرنسا', intro: 'حفلات الزفاف في أوت غارون، وسهرات شركات الطيران، ومهرجانات الصيف: تحب تولوز التجمعات الكبرى. تتزامن أساور LED لديك تلقائياً من الثانية الأولى.', venues: ['ضيعات الزفاف في أوت غارون', 'سهرات شركات الطيران', 'المهرجانات والأعياد القروية', 'نوادي وسط المدينة'] },
  },
  nice: {
    en: { region: 'Côte d\'Azur', intro: 'On the French Riviera, events are all about spectacle. A whole audience changing colour at once is the image your guests will share that very evening.', venues: ['villas & hotels on the Riviera', 'private beaches in Nice & Cannes', 'conferences & brand launches', 'club & yachting parties'] },
    ar: { region: 'فرنسا', intro: 'على الريفييرا الفرنسية، تقوم الفعاليات على الإبهار. جمهور كامل يغيّر لونه دفعةً واحدة هو الصورة التي سيشاركها ضيوفك في المساء نفسه.', venues: ['الفيلات والفنادق على الريفييرا', 'الشواطئ الخاصة في نيس وكان', 'المؤتمرات وإطلاق العلامات', 'سهرات النوادي واليخوت'] },
  },
  nantes: {
    en: { region: 'Pays de la Loire', intro: 'Nantes, with its lively cultural scene, its Loire-side weddings and its big association parties: our kits adapt from 50 to 1,000 people.', venues: ['châteaux & estates along the Loire', 'community & municipal halls', 'Nantes concerts & stages', 'corporate parties on the Île de Nantes'] },
    ar: { region: 'فرنسا', intro: 'نانت بمشهدها الثقافي النابض وحفلات زفافها على ضفاف اللوار وسهراتها الكبرى: تتكيّف أطقمنا من 50 إلى 1000 شخص.', venues: ['قصور وضيعات على ضفاف اللوار', 'القاعات الجمعوية والبلدية', 'حفلات ومسارح نانت', 'سهرات الشركات في جزيرة نانت'] },
  },
  strasbourg: {
    en: { region: 'Grand Est', intro: 'A European capital, Strasbourg lives to the rhythm of international conferences, student parties and major year-end events. Our kits are delivered ready to use across the Bas-Rhin.', venues: ['conferences & European institutions', 'student parties in the Krutenau', 'Alsatian reception estates', 'year-end events & Christmas markets'] },
    ar: { region: 'فرنسا', intro: 'عاصمة أوروبية، تعيش ستراسبورغ على إيقاع المؤتمرات الدولية وسهرات الطلاب وفعاليات نهاية العام الكبرى. تُسلَّم أطقمنا جاهزة للاستخدام في جميع أنحاء با-ران.', venues: ['المؤتمرات والمؤسسات الأوروبية', 'سهرات الطلاب في كروتناو', 'ضيعات الاستقبال الألزاسية', 'فعاليات نهاية العام وأسواق الميلاد'] },
  },
  montpellier: {
    en: { region: 'Occitanie', intro: 'Between the Mediterranean and student life, Montpellier multiplies parties, estate weddings and summer events. Our LED wristbands light up your guests from 50 to 1,000 people.', venues: ['wedding estates in the Hérault', 'beach clubs along the coast', 'student parties & unions', 'trade shows at Le Corum'] },
    ar: { region: 'فرنسا', intro: 'بين البحر المتوسط وحياة الطلاب، تكثر في مونبلييه السهرات وحفلات الزفاف في الضيعات وفعاليات الصيف. تضيء أساور LED لدينا ضيوفك من 50 إلى 1000 شخص.', venues: ['ضيعات الزفاف في الإيرولت', 'نوادي الشاطئ على الساحل', 'سهرات الطلاب والجمعيات', 'المعارض في لو كوروم'] },
  },
  rennes: {
    en: { region: 'Bretagne', intro: 'A student city and a land of festivals like the Transmusicales, Rennes loves big musical gatherings. Our LED wristband kits sync on their own to turn your parties into a show.', venues: ['student parties & galas', 'festivals & concerts', 'reception halls of the metropolis', 'corporate events in La Courrouze'] },
    ar: { region: 'فرنسا', intro: 'مدينة طلابية وأرض مهرجانات مثل ترانسميوزيكال، تحب رين التجمعات الموسيقية الكبرى. تتزامن أطقم أساور LED لدينا تلقائياً لتحويل سهراتك إلى عرض.', venues: ['سهرات وحفلات الطلاب', 'المهرجانات والحفلات الموسيقية', 'قاعات استقبال المدينة', 'فعاليات الشركات في لا كورّوز'] },
  },
  grenoble: {
    en: { region: 'Auvergne-Rhône-Alpes', intro: 'At the foot of the mountains, Grenoble brings together tech corporate events, student parties and ski-resort receptions. Our LED wristbands add a luminous dimension to every moment.', venues: ['tech corporate events on the scientific peninsula', 'ski-resort parties', 'student parties & galas', 'reception halls & estates of the Isère'] },
    ar: { region: 'فرنسا', intro: 'عند سفح الجبال، تجمع غرونوبل بين فعاليات شركات التقنية وسهرات الطلاب واستقبالات منتجعات التزلج. تضيف أساور LED لدينا بعداً مضيئاً لكل لحظة.', venues: ['فعاليات شركات التقنية في شبه الجزيرة العلمية', 'سهرات منتجعات التزلج', 'سهرات وحفلات الطلاب', 'قاعات الاستقبال والضيعات في إيزير'] },
  },
};

const FR = {
  h1: 'Bracelets LED à {city}',
  sub:
    "Nos kits sont livrés prêts à distribuer : dès que vos invités retirent la languette de protection, chaque bracelet s'allume et se synchronise seul avec tous les autres. Vous pilotez les couleurs, les vagues de lumière et les flashs depuis une mini télécommande, une application mobile ou un ordinateur, selon le contrôleur choisi.",
  ctaQuote: 'Demander mon devis gratuit',
  ctaWhatsapp: 'Nous écrire sur WhatsApp',
  ctaQuoteShort: 'Demander mon devis',
  b1t: 'De 50 à 1 000 personnes',
  b1x: 'Onze formats, du dîner intime à la grande salle.',
  b2t: '2 à 3 semaines',
  b2x: 'Délai après réception du logo et validation de la maquette.',
  b3t: 'Livraison à {city}',
  b3xFR: "Partout en France, kit complet et prêt à l'emploi.",
  b3xAE: "Via notre revendeur local aux Émirats, kit complet prêt à l'emploi.",
  venuesH2: 'Nos animations lumineuses à {city}',
  includedH2: 'Ce qui est compris dans chaque kit',
  included: [
    'Les bracelets LED ultra-premium, un par invité',
    'Un contrôleur au choix : mini contrôleur, application mobile ou ordinateur',
    'Offert : marquage 1 couleur sur le haut du bracelet',
    'Offert : la puce NFC avec programmation vers le lien de votre choix',
    'En option : animateur ou DJ avec technicien éclairage',
  ],
  quoteTitle: 'Votre devis pour {city}',
  quoteText:
    "Dites-nous le type d'événement, le nombre d'invités et la date : nous vous répondons avec le kit adapté et un tarif calculé pour votre projet, sous 24 heures ouvrées.",
  aeNote:
    " Aux Émirats, votre commande est traitée par notre revendeur local : la demande passe par ce formulaire, sans paiement en ligne.",
  kitsH2: "Nos kits prêts à l'emploi",
  ht: 'HT',
  otherCitiesH2: 'Autres villes',
  allCities: 'Toutes nos villes →',
  waMsg: 'Bonjour, je souhaite un devis pour des bracelets LED à {city}.',
};

export const CITY_COPY = {
  fr: FR,
  it: FR,
  en: {
    h1: 'LED Wristbands in {city}',
    sub:
      'Our kits arrive ready to hand out: as soon as your guests remove the protective tab, every wristband lights up and syncs on its own with all the others. You control the colours, light waves and flashes from a mini remote, a mobile app or a computer, depending on the controller you choose.',
    ctaQuote: 'Request a free quote',
    ctaWhatsapp: 'Message us on WhatsApp',
    ctaQuoteShort: 'Request a quote',
    b1t: 'From 50 to 1,000 people',
    b1x: 'Eleven formats, from an intimate dinner to a large venue.',
    b2t: '2 to 3 weeks',
    b2x: 'Lead time after we receive your logo and approve the mock-up.',
    b3t: 'Delivery to {city}',
    b3xFR: 'Anywhere in France, a complete ready-to-use kit.',
    b3xAE: 'Through our local reseller in the UAE, a complete ready-to-use kit.',
    venuesH2: 'Our light shows in {city}',
    includedH2: "What's included in every kit",
    included: [
      'Ultra-premium LED wristbands, one per guest',
      'A controller of your choice: mini remote, mobile app or computer',
      'Free: 1-colour printing on top of the wristband',
      'Free: NFC chip programmed to the link of your choice',
      'Optional: host or DJ with a lighting technician',
    ],
    quoteTitle: 'Your quote for {city}',
    quoteText:
      'Tell us the type of event, the number of guests and the date: we reply with the right kit and a price tailored to your project within 24 business hours.',
    aeNote:
      ' In the UAE, your order is handled by our local reseller: the request goes through this form, with no online payment.',
    kitsH2: 'Our ready-to-use kits',
    ht: 'excl. VAT',
    otherCitiesH2: 'Other cities',
    allCities: 'All our cities →',
    waMsg: "Hello, I'd like a quote for LED wristbands in {city}.",
  },
  ar: {
    h1: 'أساور LED في {city}',
    sub:
      'تصل أطقمنا جاهزة للتوزيع: بمجرد أن يزيل ضيوفك شريط الحماية، يضيء كل سوار ويتزامن تلقائياً مع البقية. تتحكم في الألوان وموجات الضوء والوميض من ريموت صغير أو تطبيق جوال أو كمبيوتر حسب وحدة التحكم التي تختارها.',
    ctaQuote: 'اطلب عرض سعر مجاني',
    ctaWhatsapp: 'راسلنا على واتساب',
    ctaQuoteShort: 'اطلب عرض سعر',
    b1t: 'من 50 إلى 1000 شخص',
    b1x: 'أحد عشر حجماً، من العشاء الحميم إلى القاعة الكبرى.',
    b2t: 'من أسبوعين إلى 3 أسابيع',
    b2x: 'المدة بعد استلام الشعار واعتماد التصميم.',
    b3t: 'التوصيل إلى {city}',
    b3xFR: 'في جميع أنحاء فرنسا، طقم كامل جاهز للاستخدام.',
    b3xAE: 'عبر موزّعنا المحلي في الإمارات، طقم كامل جاهز للاستخدام.',
    venuesH2: 'عروضنا الضوئية في {city}',
    includedH2: 'ما الذي يتضمنه كل طقم',
    included: [
      'أساور LED فائقة الجودة، واحدة لكل ضيف',
      'وحدة تحكم من اختيارك: ريموت صغير أو تطبيق جوال أو كمبيوتر',
      'مجاناً: طباعة بلون واحد على أعلى السوار',
      'مجاناً: شريحة NFC مبرمجة إلى الرابط الذي تختاره',
      'اختياري: منشّط أو دي جي مع فني إضاءة',
    ],
    quoteTitle: 'عرض السعر الخاص بك في {city}',
    quoteText:
      'أخبرنا بنوع الفعالية وعدد الضيوف والتاريخ: نردّ عليك بالطقم المناسب وبسعر مخصّص لمشروعك خلال 24 ساعة عمل.',
    aeNote:
      ' في الإمارات، تتم معالجة طلبك عبر موزّعنا المحلي: يمر الطلب عبر هذا النموذج دون دفع إلكتروني.',
    kitsH2: 'أطقمنا الجاهزة للاستخدام',
    ht: 'بدون ضريبة',
    otherCitiesH2: 'مدن أخرى',
    allCities: 'جميع مدننا ←',
    waMsg: 'مرحباً، أرغب في عرض سعر لأساور LED في {city}.',
  },
};

// Titres/descriptions SEO pour les pages UAE selon la langue.
export const CITY_SEO = {
  en: {
    title: 'LED Wristbands {city} — light animation for events | Party LED',
    description:
      'Light animation in {city}: synchronized LED wristband kits from 50 to 1,000 people. Free 1-colour printing, quote within 24 hours.',
  },
  ar: {
    title: 'أساور LED في {city} — إضاءة للفعاليات | Party LED',
    description:
      'إضاءة للفعاليات في {city}: أطقم أساور LED متزامنة من 50 إلى 1000 شخص. طباعة بلون واحد مجاناً وعرض سعر خلال 24 ساعة.',
  },
};
